import { BRAND, TEXT } from "../dashboard-v2/shared/styles";
import CarbonJourney from "./CarbonJourney";
import Reveal from "./Reveal";

export default function IntroVideo() {
  return (
    <div className="sdx" style={{ padding: "2rem", textAlign: "center" }}>
      <Reveal>
        {/* Title */}
        <h2
          className="h2 lp-accent"
          style={{
            fontWeight: "bold",
            marginBottom: "1rem",
            textAlign: "center",
            color: BRAND,
          }}
        >
          CO2-Management, das sich rechnet.
        </h2>

        {/* Description */}
        <p className="p" style={{ maxWidth: "800px", margin: "1rem auto", color: TEXT }}>
          Die Plattform erfasst den CO2-Fussabdruck Ihres Carrosserie- und Lackierbetriebs
          automatisch und deckt auf, wo Energie, Material und Geld verloren gehen. Sie erhalten
          konkrete, nach Einsparpotenzial priorisierte Massnahmen, inklusive Förder-Hinweisen und
          sehen, wo Sie im Vergleich zur Branche stehen.
        </p>
      </Reveal>

      <CarbonJourney />
    </div>
  );
}
